import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { TbDeviceGamepad2 } from 'react-icons/tb'
import { IoChevronDown } from 'react-icons/io5'
import { BiVideoPlus } from 'react-icons/bi'
import { CgGames } from 'react-icons/cg'

const SidebarTitlesMenu = () => {
  const location = useLocation()
  const [titlesOpen, setTitlesOpen] = useState(false)

  const pathname = location.pathname
  const isTitlesSection = pathname === '/type' || pathname.startsWith('/type/')
  const isGamesActive = pathname.startsWith('/type/games')
  const isVideosActive = pathname.startsWith('/type/videos')
  const isAllActive = isTitlesSection && !isGamesActive && !isVideosActive

  useEffect(() => {
    if (isGamesActive || isVideosActive) {
      setTitlesOpen(true)
    }
  }, [isGamesActive, isVideosActive])

  return (
    <div
      className={`sidebarDropdown ${titlesOpen ? 'open' : ''} ${isTitlesSection ? 'active' : ''}`}
    >
      <div className="sidebarDropdown__toggle sidebarDropdown__toggle--split">
        <Link
          to="/type/all"
          className={`sidebarDropdown__mainLink ${isAllActive ? 'isCurrentPage' : ''}`}
          aria-current={isAllActive ? 'page' : undefined}
        >
          <TbDeviceGamepad2 />
          <span>عناوین</span>
        </Link>

        <button
          type="button"
          className="sidebarDropdown__arrowBtn"
          aria-label="باز کردن زیرمنوی عناوین"
          aria-expanded={titlesOpen}
          onClick={() => setTitlesOpen((prev) => !prev)}
        >
          <IoChevronDown className="sidebarDropdown__arrow" />
        </button>
      </div>

      <div className="sidebarDropdown__menu">
        <Link
          to="/type/games"
          className={isGamesActive ? 'isCurrentPage' : undefined}
          aria-current={isGamesActive ? 'page' : undefined}
          onClick={() => setTitlesOpen(true)}
        >
          <CgGames />
          <span>بازی‌ها</span>
        </Link>

        <Link
          to="/type/videos"
          className={isVideosActive ? 'isCurrentPage' : undefined}
          aria-current={isVideosActive ? 'page' : undefined}
          onClick={() => setTitlesOpen(true)}
        >
          <BiVideoPlus />
          <span>ویدئوها</span>
        </Link>
      </div>
    </div>
  )
}

export default SidebarTitlesMenu
